import createAxiosInstance from "../utils/axiosInstance";
import Env from "../env/Env";

const request = createAxiosInstance(`${Env.API_BASE}/api/admins/cron-server`);

const cronServerAPIsService = {
  /**
   * Get health status from cron server
   */
  getHealthStatus: (signal?: AbortSignal): Promise<any> => {
    return new Promise((resolve, reject) => {
      request
        .get("/health", { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  /**
   * Trigger full sync operation
   */
  triggerFullSync: (signal?: AbortSignal): Promise<any> => {
    return new Promise((resolve, reject) => {
      request
        .post("/full-sync", {}, { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  /**
   * Trigger completion sync operation
   */
  triggerCompletionSync: (signal?: AbortSignal): Promise<any> => {
    return new Promise((resolve, reject) => {
      request
        .post("/completion-sync", {}, { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  /**
   * Trigger cleanup operation
   */
  triggerCleanup: (signal?: AbortSignal): Promise<any> => {
    return new Promise((resolve, reject) => {
      request
        .post("/cleanup", {}, { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  /**
   * Trigger compliance sync operation
   */
  triggerComplianceSync: (from: string, to: string, dryRun: boolean = false, signal?: AbortSignal): Promise<any> => {
    return new Promise((resolve, reject) => {
      request
        .post("/compliance-sync", { from, to, dryRun }, { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  /**
   * Get sync status
   */
  getSyncStatus: (signal?: AbortSignal): Promise<any> => {
    return new Promise((resolve, reject) => {
      request
        .get("/sync-status", { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  /**
   * Get scheduled cron status
   */
  getScheduledCronStatus: (signal?: AbortSignal): Promise<any> => {
    return new Promise((resolve, reject) => {
      request
        .get("/scheduled-cron-status", { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  /**
   * Get logs from cron server
   */
  getLogs: (latest: boolean = false, signal?: AbortSignal): Promise<string> => {
    return new Promise((resolve, reject) => {
      request
        .get("/logs", { 
          params: { latest },
          signal,
          responseType: 'text'
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  /**
   * Force release all locks
   */
  forceReleaseLocks: (signal?: AbortSignal): Promise<any> => {
    return new Promise((resolve, reject) => {
      request
        .post("/force-release-locks", {}, { signal })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  }
};

export default cronServerAPIsService;
